import BuyEvent from './BuyEvent';

export default BuyEvent;
